import * as _ from 'lodash';
import { forkJoin } from 'rxjs/observable/forkJoin';

import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService, AlertService, DateUtils } from 'ng-jhipster';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';


// ag grid
import {GridOptions} from '@ag-grid-community/all-modules';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import {CsvExportModule} from '@ag-grid-community/csv-export';

import { Account, LoginModalService, Principal } from '../shared';
import { Student, StudentService } from '../entities/student';
import { CardService, Card, CardStats } from '../entities/card';
import { SchoolCalendarService, SchoolCalendar } from '../entities/school-calendar';
import { TranslateService } from 'ng2-translate';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

@Component({
    selector: 'users-finantial-status-report',
    templateUrl: './users-finantial-status-report-component.html'
})
export class UsersFinantialStatusReportComponent implements OnInit {
    account: Account;
    modalRef: NgbModalRef;
    student: Student;
    isLoading: boolean = true;
    cards: Card[];

    schoolCalendars: SchoolCalendar[];
    selectedSchoolCalendar: SchoolCalendar;

    private gridOptions: GridOptions;
    public rowData: any[];
    private columnDefs: any[];
    private defaultColDef;
    public modules: any[] = [ClientSideRowModelModule, CsvExportModule];
    private gridApi;
    private gridColumnApi;

    constructor(
        private alertService: AlertService,
        private jhiLanguageService: JhiLanguageService,
        private principal: Principal,
        private loginModalService: LoginModalService,
        private cardService: CardService,
        private eventManager: EventManager,
        private studentService: StudentService,
        private schoolCalendarService: SchoolCalendarService,
        private translateService: TranslateService,
        private dateFormatter: NgbDateParserFormatter,
        private dateUtils: DateUtils,
        private languageService: JhiLanguageService
    ) {
        this.jhiLanguageService.setLocations(['users-finantial-status-report']);
    }

    ngOnInit() {
        this.defaultColDef = {
            editable: true,
            resizable: true,
            minWidth: 100,
            flex: 1,
         };

         // initialize the headers with the configured language
         forkJoin(
             this.translateService.get('jYoguiApp.users-finantial-status-report.grid.login'),
             this.translateService.get('jYoguiApp.users-finantial-status-report.grid.email'),
             this.translateService.get('jYoguiApp.users-finantial-status-report.grid.name'),
             this.translateService.get('jYoguiApp.users-finantial-status-report.grid.lastName'),
             this.translateService.get('jYoguiApp.users-finantial-status-report.grid.formule'),
             this.translateService.get('jYoguiApp.users-finantial-status-report.grid.validSince'),
             this.translateService.get('jYoguiApp.users-finantial-status-report.grid.validUntil'),
             this.translateService.get('jYoguiApp.users-finantial-status-report.grid.price'),
             this.translateService.get('jYoguiApp.users-finantial-status-report.grid.payed'),
             this.translateService.get('jYoguiApp.users-finantial-status-report.grid.debt'),
         ).subscribe((response: Response[]) => {
            this.columnDefs = [
                {headerName: response[0], field: 'login', sortable: true, filter: true},
                {headerName: response[1], field: 'email', sortable: true, filter: true},
                {headerName: response[2], field: 'name', sortable: true, filter: true},
                {headerName: response[3], field: 'lastName', sortable: true, filter: true},
                {headerName: response[4], field: 'formule', sortable: true, filter: true},
                {headerName: response[5], field: 'validSince', sortable: true, filter: true},
                {headerName: response[6], field: 'validUntil', sortable: true, filter: true},
                {headerName: response[7], field: 'price', sortable: true, filter: true},
                {headerName: response[8], field: 'totalPaid', sortable: true, filter: true},
                {headerName: response[9], field: 'totalDebt', sortable: true, filter: true,  sort: 'desc'}
            ];
         });

        this.principal.identity().then((account) => {
            this.account = account;

            this.loadCurrentStudent()
            .add(() => {
                this.loadSchoolCalendar()
                .add(() => {
                    this.loadData();
                });
            });
        });
    }

    onGridReady(params) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
    }

    onBtnExport() {
        this.gridApi.exportDataAsCsv({
            suppressQuotes: true,
            columnSeparator: ';'
        });
    }

    private loadCurrentStudent() {
        return this.studentService.getCurrent()
            .subscribe((student: Student) => {
                this.student = student;
            });
    }

    public selectedSchoolCalendarChanged($event) {
        this.gridApi.showLoadingOverlay();
        this.loadData();
    }

    private loadSchoolCalendar() {
        return this.schoolCalendarService.search({
            query: `school.id:${this.student.schoolId}`,
            sort: ['begining,desc']
        })
        .subscribe((res: HttpResponse<SchoolCalendar[]>) => {
            this.schoolCalendars = res.body;
            // Take the last one
            this.selectedSchoolCalendar = this.schoolCalendars[0];
        });
    }

    private  loadData() {
        this.isLoading = true;

        const datePipe = new DatePipe(this.languageService.currentLang);
        const beginning = datePipe.transform(this.selectedSchoolCalendar.begining, 'yyyy-MM-dd');
        const ending = datePipe.transform(this.selectedSchoolCalendar.ending, 'yyyy-MM-dd');

        this.cardService.search({
            page: 0,
            query: `validUntil:[${beginning} TO ${ending}]`,
            size: 5000,
        }).subscribe(
            (res: HttpResponse<Card[]>) => this.onSuccess(res.body, res.headers),
            (res: HttpErrorResponse) => this.onError(res)
            );
    }

    private onSuccess(data, headers) {
        this.cards = data;
        this.rowData = [];
        this.cards.forEach(c => {

            // we convert the dates from the server
            let validSinceDate = this.dateUtils.convertDateTimeFromServer(c.validSince);
            let validUntilDate = this.dateUtils.convertDateTimeFromServer(c.validUntil);

            this.rowData.push({
                login: c.student.user.login,
                email: c.student.user.email,
                name: c.student.user.firstName,
                lastName: c.student.user.lastName,
                formule: c.cardType.name,
                validSince: this.dateFormatter
                                .format({
                                    day : validSinceDate.getDate(),
                                    month: validSinceDate.getMonth() + 1,
                                    year: validSinceDate.getFullYear()
                                }),
                validUntil: this.dateFormatter
                    .format({
                        day : validUntilDate.getDate(),
                        month: validUntilDate.getMonth() + 1,
                        year: validUntilDate.getFullYear()
                    }),
                price: c.price,
                totalPaid: c.totalPaid,
                totalDebt: c.price - c.totalPaid});
        });
        this.isLoading = false;
    }

    private onError(error: HttpErrorResponse) {
        this.alertService.error(error.error, null, null);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/users-finantial-status-report/users-finantial-status-report.component.ts